import { createNormalizedMap } from 'action-utils';
import { AsyncActionHandler } from 'action-handler';

import { setCurrentlySyncing } from 'actions/gallery';

export default new AsyncActionHandler({
  name: 'notify_app_install_progress',
  defaultState: {
    appProgress: {}
  },
  handler({ apps }) {
    return (dispatch) => {
      const possibleWifiSync = !apps || apps.length === 0;
      dispatch(setCurrentlySyncing({ wifi: possibleWifiSync }));
      return { apps };
    };
  },
  reduce(state, { apps }) {
    return {
      appProgress: {
        ...state.appProgress,
        ...createNormalizedMap(apps, state.appProgress, 'appId')
      }
    };
  }
});
